import { Skeleton } from "@/components/ui/feedback/Skeleton";
import { cn } from "@/lib/cn";
import type { TableSkeletonProps } from "./DataTable.types";

const skeletonMetricClassName = {
  cell: "bfrs-h-16 bfrs-px-5 bfrs-py-4",
  primary: "bfrs-h-3.5",
  secondary: "bfrs-h-2.5"
} as const;

const skeletonWidthClassName = ["bfrs-w-24", "bfrs-w-32", "bfrs-w-20", "bfrs-w-36", "bfrs-w-28", "bfrs-w-40", "bfrs-w-16"] as const;

export function TableSkeleton({ rows = 5, columns = 4, colSpan }: TableSkeletonProps) {
  const cellCount = Math.max(1, colSpan ?? columns);

  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex} aria-hidden="true">
          {Array.from({ length: cellCount }).map((__, columnIndex) => {
            const widthClassName = skeletonWidthClassName[(rowIndex + columnIndex) % skeletonWidthClassName.length];
            const showSecondaryLine = columnIndex === 0 || (columnIndex + rowIndex) % 4 === 0;

            return (
              <td key={columnIndex} className={cn("bfrs-border-b bfrs-border-border bfrs-bg-surface-card bfrs-align-middle", skeletonMetricClassName.cell)}>
                <div className="bfrs-flex bfrs-min-w-0 bfrs-flex-col bfrs-gap-2">
                  <Skeleton variant="text" className={cn(skeletonMetricClassName.primary, widthClassName, columnIndex === cellCount - 1 && "bfrs-w-14")} />
                  {showSecondaryLine && <Skeleton variant="text" className={cn(skeletonMetricClassName.secondary, columnIndex === 0 ? "bfrs-w-28" : "bfrs-w-16", "bfrs-opacity-70")} />}
                </div>
              </td>
            );
          })}
        </tr>
      ))}
    </>
  );
}
